import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";

import { useQueryProfile } from "../../graphql/apollo/useQuery";
import { TRANSLATE } from "../../i18n/translation";
import { hooks } from "../../hooks";
import { APP_ROUTES } from "../../constants/app_routes";

const TradeHeader = () => {
  const { t } = useTranslation();
  const { myProfile } = useQueryProfile();
  const navigate = hooks.useNavigate();

  return (
    <div className="trade-header">
      <div className="trade-header__balance">
        <p>{t(TRANSLATE.BALANCE)}</p>
        <p>${myProfile?.balance.toFixed(2)}</p>
      </div>
      <Button
        variant="outlined"
        color="warning"
        onClick={() => navigate(APP_ROUTES.SUPPORT)}
      >
        {t(TRANSLATE.DEPOSIT)}
      </Button>
    </div>
  );
};

export default TradeHeader;
